import type { CicloPublico } from "@caint/shared";
import { useEffect, useMemo, useState } from "react";
import { mensagemAmigavel } from "../lib/erros.ts";
import type { CiclosApi } from "../state/useAppState.ts";
import { PainelImgr } from "./PainelImgr.tsx";

/**
 * Dashboard do formulário público (IMGR) por ciclo. Fluxo: escolhe a unidade
 * (ciclo) que TEM formulário ativo (token público) e vê o dashboard completo —
 * indicadores, recortes por cargo/nível/perfil/área e perguntas críticas.
 */
export function ResultadosPublico({ ciclosApi }: { ciclosApi: CiclosApi }) {
  const [ciclos, setCiclos] = useState<CicloPublico[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);
  const [sel, setSel] = useState("");

  useEffect(() => {
    let vivo = true;
    ciclosApi
      .listar()
      .then((cs) => {
        if (!vivo) {
          return;
        }
        // Só ciclos com formulário ATIVO (token público gerado).
        const comFormulario = cs.filter((c) => c.tokenPublico != null);
        setCiclos(comFormulario);
        setSel(comFormulario.find((c) => c.status === "aberto")?.id ?? comFormulario[0]?.id ?? "");
      })
      .catch((e) => vivo && setErro(mensagemAmigavel(e)));
    return () => {
      vivo = false;
    };
  }, [ciclosApi]);

  const ciclo = useMemo(() => ciclos?.find((c) => c.id === sel) ?? ciclos?.[0], [ciclos, sel]);

  if (erro) {
    return <p style={{ color: "var(--danger)" }}>{erro}</p>;
  }
  if (ciclos === null) {
    return <p className="spec">Carregando dashboard…</p>;
  }
  if (ciclos.length === 0) {
    return (
      <p className="spec">
        Nenhum ciclo com formulário ativo. Abra um ciclo para gerar o formulário público.
      </p>
    );
  }

  return (
    <div>
      <p className="spec" style={{ marginBottom: 12 }}>
        Dashboard das respostas anônimas do formulário público, consolidadas em IMGR por ciclo (unidade).
      </p>
      {ciclos.length > 1 && (
        <select
          className="m-select"
          style={{ marginBottom: 14 }}
          value={sel}
          onChange={(e) => setSel(e.target.value)}
        >
          {ciclos.map((c) => (
            <option key={c.id} value={c.id}>
              {c.unidadeNome} · {c.status === "aberto" ? "aberto" : "encerrado"}
            </option>
          ))}
        </select>
      )}
      {ciclo && <PainelImgr ciclo={ciclo} carregar={ciclosApi.resultado} />}
    </div>
  );
}
